import { mapState } from 'vuex';
import { toLiteral, toNumeral } from 'util/dom/mq';

/**
 * Check two numbers for proximity to a certain goal and return the closer one
 * @param {number} a - Value a
 * @param {number} b - Value b
 * @param {number} goal - The target number
 * @return {number} The closer number of the two
 */
function findClosest(a, b, goal) {
    const isCloser = Math.abs(b - goal) <= Math.abs(a - goal);
    return isCloser ? b : a;
}

export default {
    props: {
        /** @type {IImageSetUrls} */
        urls: {
            type: Object,
            default() {
                return {
                    default: [],
                };
            },
        },
    },
    computed: {
        ...mapState('viewport', ['mq']),

        bestPicture() {
            const goal = toNumeral(this.mq.query);
            const keys = Object.keys(this.urls);

            if (keys.length === 1) {
                return this.urls[keys[0]];
            }

            const closestNumeral = keys
                .map(literal => toNumeral(literal))
                .reduce((a, b) => findClosest(a, b, goal));

            return this.urls[toLiteral(closestNumeral)];
        },
    },
};
